"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_service_1 = require("../../shared/service/http.service");
var store_1 = require("@angular-redux/store");
var find_http_error_1 = require("../../shared/error/find-http-error");
var Subject_1 = require("rxjs/Subject");
var attending_1 = require("../model/attending");
var update_http_error_1 = require("../../shared/error/update-http-error");
var accessory_amount_service_1 = require("../../shared/service/accessory-amount.service");
var delete_http_error_1 = require("../../shared/error/delete-http-error");
var page_info_1 = require("../../shared/model/page-info");
var attending_info_1 = require("../model/attending-info");
var moment = require("moment");
var authentication_service_1 = require("../../shared/service/authentication.service");
var save_http_error_1 = require("../../shared/error/save-http-error");
var boolean_value_1 = require("../../shared/model/boolean-value");
var monitoring_1 = require("../model/monitoring");
var attending_score_1 = require("../model/attending-score");
var AttendingService = /** @class */ (function () {
    function AttendingService(_httpService, _authService, _accessoryAmountService, _ngRedux) {
        this._httpService = _httpService;
        this._authService = _authService;
        this._accessoryAmountService = _accessoryAmountService;
        this._ngRedux = _ngRedux;
        this.FIND_BY_FILTER = AttendingService.ATTENDING_END_POINT + "/findByFilter";
        this.SHOW_CURRENT = AttendingService.ATTENDING_END_POINT + "/showCurrent";
        this.BUILD = AttendingService.ATTENDING_END_POINT + "/build";
        this.CREATE = AttendingService.ATTENDING_END_POINT + "/create";
        this.UPDATE = AttendingService.ATTENDING_END_POINT + "/update";
        this.FINISH = AttendingService.ATTENDING_END_POINT + "/finish";
        this.DELETE = AttendingService.ATTENDING_END_POINT + "/delete";
        this.FINISH_MONITORING = AttendingService.ATTENDING_END_POINT + "/finishMonitoring";
        this.FIND_PAGE_INFO = AttendingService.ATTENDING_END_POINT + "/findPageInfo";
        this.ASSIGN_TO_USER = AttendingService.ATTENDING_END_POINT + "/assign";
        this.UNASSIGN_TO_USER = AttendingService.ATTENDING_END_POINT + "/unassign";
        this.ASSOCIATE_DIAGNOSIS = AttendingService.ATTENDING_END_POINT + "/associateDiagnosis";
        this.FIND_ATTENDING_INFO = AttendingService.ATTENDING_END_POINT + "/info";
        this.FIND_ATTENDING_KIT = AttendingService.ATTENDING_END_POINT + "/kit";
        this.CONVERT_ATTENDING = AttendingService.ATTENDING_END_POINT + "/convert";
        this.ATTENDING_STATUS = AttendingService.ATTENDING_END_POINT + "/status";
        this.INFO_FILE = AttendingService.ATTENDING_END_POINT + "/info-file";
        this.MONITORING_VALIDATION_STEP = AttendingService.ATTENDING_END_POINT + "/monitoring/validation";
        this.MONITORING = AttendingService.ATTENDING_END_POINT + "/monitoring";
        this.SET_TECHNICIAN_SCORE = AttendingService.ATTENDING_END_POINT + "/score";
        this.RESCHEDULE_ATTENDING = AttendingService.ATTENDING_END_POINT + "/reschedule";
        this.UPDATE_EQUIPMENT_INFO = AttendingService.ATTENDING_END_POINT + "/equipment-info";
        this.saveSubject = new Subject_1.Subject();
        this.save$ = this.saveSubject.asObservable();
        this.finishSubject = new Subject_1.Subject();
        this.finish$ = this.finishSubject.asObservable();
        this.createSubject = new Subject_1.Subject();
        this.create$ = this.createSubject.asObservable();
        this.currentSubject = new Subject_1.Subject();
        this.current$ = this.currentSubject.asObservable();
        this.buildSubject = new Subject_1.Subject();
        this.build$ = this.buildSubject.asObservable();
        this.findSubject = new Subject_1.Subject();
        this.find$ = this.findSubject.asObservable();
        this.findMovementsSubject = new Subject_1.Subject();
        this.findMovements$ = this.findMovementsSubject.asObservable();
        this.pageInfoSubject = new Subject_1.Subject();
        this.pageInfo$ = this.pageInfoSubject.asObservable();
        this.deleteSubject = new Subject_1.Subject();
        this.delete$ = this.deleteSubject.asObservable();
        this.errorSubject = new Subject_1.Subject();
        this.error$ = this.errorSubject.asObservable();
    }
    AttendingService.prototype.create = function () {
        var _this = this;
        this._httpService.get(this.CREATE, attending_1.Attending, find_http_error_1.FindHttpError)
            .subscribe(function (attending) { return _this.createSubject.next(attending); }, function (error) { return _this.errorSubject.next(error); });
    };
    AttendingService.prototype.updateAttending = function (data) {
        var _this = this;
        this._httpService.put(this.UPDATE, data.attending, attending_1.Attending, update_http_error_1.UpdateHttpError)
            .subscribe(function (attending) { return _this.saveSubject.next(attending); }, function (error) { return _this.errorSubject.next(error); });
    };
    AttendingService.prototype.saveConfiguration = function (attending) {
        if (attending.configuration.simCard || attending.configuration.simCard.iccid) {
            this.updateAttending({ attending: attending });
        }
        else {
            this.errorSubject.next({ text: 'Preencha a configuração corretamente.' });
        }
    };
    AttendingService.prototype.saveDispatch = function (attending) {
        this.updateAttending({ attending: attending });
    };
    AttendingService.prototype.saveScheduling = function (attending) {
        this.updateAttending({ attending: attending });
    };
    AttendingService.prototype.finishMonitoring = function (finishMonitoringDto) {
        var _this = this;
        return this._httpService.put(this.FINISH_MONITORING, finishMonitoringDto, attending_1.Attending, update_http_error_1.UpdateHttpError)
            .subscribe(function () { return _this.finishSubject.next(); }, function (error) { return _this.errorSubject.next(error); });
    };
    AttendingService.prototype.saveValidation = function (data) {
        var _this = this;
        this._httpService.put(this.FINISH, data.attending, attending_1.Attending, update_http_error_1.UpdateHttpError)
            .subscribe(function () { return _this.finishSubject.next(); }, function (error) { return _this.errorSubject.next(error); });
    };
    AttendingService.prototype.build = function (id) {
        var _this = this;
        this._httpService.get(this.BUILD + "/" + id, attending_1.Attending, find_http_error_1.FindHttpError)
            .subscribe(function (attending) { return _this.buildSubject.next(attending); }, function (error) { return _this.errorSubject.next(error); });
    };
    AttendingService.prototype.convertAttending = function (id, conversion) {
        var _this = this;
        this._httpService.post(this.CONVERT_ATTENDING + "/" + id, conversion, attending_1.Attending, save_http_error_1.SaveHttpError)
            .subscribe(function (attending) { return _this.saveSubject.next(attending); }, function (error) { return _this.errorSubject.next(error); });
    };
    AttendingService.prototype.assignMonitoringToUser = function (attendingId) {
        var _this = this;
        this._httpService.post(this.ASSIGN_TO_USER + "/" + attendingId + "?stepType=MONITORING", {}, Object, update_http_error_1.UpdateHttpError)
            .subscribe(function () { }, function (error) {
            _this.errorSubject.next(new update_http_error_1.UpdateHttpError('Não foi possível atribuir você para esse monitoramento.'));
        });
    };
    AttendingService.prototype.unassignMonitoringToUser = function (attendingId) {
        var _this = this;
        this._httpService.post(this.UNASSIGN_TO_USER + "/" + attendingId + "?stepType=MONITORING", {}, Object, update_http_error_1.UpdateHttpError)
            .subscribe(function () { }, function (error) {
            _this.errorSubject.next(new update_http_error_1.UpdateHttpError('Não foi possível remover você do monitoramento.'));
        });
    };
    AttendingService.prototype.showCurrent = function (id) {
        var _this = this;
        this._httpService.get(this.SHOW_CURRENT + "/" + id, attending_1.Attending, find_http_error_1.FindHttpError)
            .subscribe(function (attending) { return _this.currentSubject.next(attending); }, function (error) { return _this.errorSubject.next(error); });
    };
    AttendingService.prototype.delete = function (id) {
        return this._httpService.delete(this.DELETE + "/" + id, attending_1.Attending, delete_http_error_1.DeleteHttpError);
    };
    AttendingService.prototype.findAttendings = function (pageNumber, pageSize) {
        var _this = this;
        this._ngRedux.select('attendingFilter')
            .subscribe(function (filter) {
            var newFilter = __assign({}, filter);
            _this.assembleFilter(newFilter);
            _this.findByFilter(newFilter, pageNumber, pageSize);
            _this.findPageInfo(newFilter, pageSize);
        });
    };
    AttendingService.prototype.findAttendingInfo = function (id) {
        var _this = this;
        this._httpService.get(this.FIND_ATTENDING_INFO + "/" + id, attending_info_1.default, find_http_error_1.FindHttpError)
            .subscribe(function (attendingInfo) { return _this.findSubject.next(attendingInfo); }, function (error) { });
    };
    AttendingService.prototype.findAttendingKit = function (attending) {
        var _this = this;
        this._httpService.post(this.FIND_ATTENDING_KIT, attending, Array, find_http_error_1.FindHttpError)
            .subscribe(function (accessoryMovementLogs) { return _this.findMovementsSubject.next(accessoryMovementLogs); }, function (error) { return _this.errorSubject.next(error); });
    };
    AttendingService.prototype.getVehicleParts = function (id, period) {
        return this._httpService.get(AttendingService.ATTENDING_END_POINT + "/" + id + "/vehicleparts?period=" + period, Map, find_http_error_1.FindHttpError);
    };
    AttendingService.prototype.deleteInfoFile = function (id, attendingId) {
        return this._httpService.delete(this.INFO_FILE + "/" + id + "?attendingId=" + attendingId, boolean_value_1.BooleanValue, delete_http_error_1.DeleteHttpError);
    };
    AttendingService.prototype.acceptInfoFile = function (id, accepted, attendingId) {
        return this._httpService.put(this.INFO_FILE + "?accepted=" + accepted + "&attendingId=" + attendingId, id, boolean_value_1.BooleanValue, update_http_error_1.UpdateHttpError);
    };
    AttendingService.prototype.updateStatus = function (id, status) {
        return this._httpService.put(this.ATTENDING_STATUS + "?status=" + status, id, boolean_value_1.BooleanValue, update_http_error_1.UpdateHttpError);
    };
    AttendingService.prototype.setMonitoringValidationStep = function (monitoring) {
        return this._httpService.post("" + this.MONITORING_VALIDATION_STEP, monitoring, boolean_value_1.BooleanValue, find_http_error_1.FindHttpError);
    };
    AttendingService.prototype.findMonitoring = function (id) {
        return this._httpService.get(this.MONITORING + "/" + id, monitoring_1.Monitoring, find_http_error_1.FindHttpError);
    };
    AttendingService.prototype.setTechnicianScore = function (id, score) {
        return this._httpService.post(this.SET_TECHNICIAN_SCORE + "/" + id, score, attending_score_1.AttendingScore, save_http_error_1.SaveHttpError);
    };
    AttendingService.prototype.reschedule = function (id) {
        var _this = this;
        this._httpService.put(this.RESCHEDULE_ATTENDING, id, attending_1.Attending, update_http_error_1.UpdateHttpError)
            .subscribe(function () { return _this.finishSubject.next(); }, function (error) { return _this.errorSubject.next(error); });
    };
    AttendingService.prototype.assembleFilter = function (newFilter) {
        if (newFilter.scheduleDate) {
            newFilter.scheduleDate = moment(newFilter.scheduleDate, 'DD/MM/YYYY');
        }
        if (newFilter.monitoringUser) {
            newFilter.monitoringUser = this._authService.getUserFromLocalStorage();
        }
        else {
            newFilter.monitoringUser = null;
        }
        return newFilter;
    };
    AttendingService.prototype.findByFilter = function (filter, pageNumber, pageSize) {
        var _this = this;
        this._httpService.post(this.FIND_BY_FILTER + "?pageNumber=" + pageNumber + "&pageSize=" + pageSize, filter, Array, find_http_error_1.FindHttpError)
            .subscribe(function (attendings) { return _this.findSubject.next(attendings); }, function (error) { return _this.errorSubject.next(error); });
    };
    AttendingService.prototype.findPageInfo = function (filter, pageSize) {
        var _this = this;
        this._httpService.post(this.FIND_PAGE_INFO + "?pageSize=" + pageSize, filter, page_info_1.PageInfo, find_http_error_1.FindHttpError)
            .subscribe(function (pageInfo) { return _this.pageInfoSubject.next(pageInfo); }, function (error) { return _this.errorSubject.next(error); });
    };
    AttendingService.prototype.updateEquipmentInfo = function (id, equipmentSimCardUpdate) {
        return this._httpService.put(this.UPDATE_EQUIPMENT_INFO + "/" + id, equipmentSimCardUpdate, boolean_value_1.BooleanValue, update_http_error_1.UpdateHttpError);
    };
    AttendingService.prototype.getCanContinueMonitoringWorkFlow = function (id, period) {
        return this._httpService.get(AttendingService.ATTENDING_END_POINT + "/can-continue-monitoring-workflow/" + id + "?period=" + period, boolean_value_1.BooleanValue, find_http_error_1.FindHttpError);
    };
    AttendingService.ctorParameters = function () { return [{ type: http_service_1.HttpService }, { type: authentication_service_1.AuthenticationService }, { type: accessory_amount_service_1.AccessoryAmountService }, { type: store_1.NgRedux }]; };
    AttendingService.ATTENDING_END_POINT = '/attending';
    return AttendingService;
}());
exports.AttendingService = AttendingService;
//# sourceMappingURL=attending.service.js.map


// WEBPACK FOOTER //
// attending.service.js